/* eslint-disable jsx-a11y/control-has-associated-label */
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';
import { useNewsBondCurrentPageHandlers } from '../../../../../../context';
import { NewsBondPagerElementContainer } from './components';

const style: ouiStyle.InStyle = {
  lines: 0.4,
  widthLines: 0.4,
  borderRadius: 'full',
  cursor: 'pointer',
};

export const NewsBondPagerElement = (props: {
  page: number,
}) => {
  const {
    page,
  } = props;
  const [currentPage, setPage] = useNewsBondCurrentPageHandlers();
  const onClick = React.useCallback(
    () => {
      setPage(page);
    },
    [setPage, page],
  );
  const css = React.useMemo(
    () => ouiStyle.makeCss({
      ...style,
      backgroundColor: currentPage === page
        ? ouiStyle.Constants.Colors.accent
        : ouiStyle.Constants.Colors.evenDarkerFade,
    }),
    [currentPage, page],
  );
  return (
    <NewsBondPagerElementContainer>
      <button
        type="button"
        onClick={onClick}
        css={css}
      />
    </NewsBondPagerElementContainer>
  );
};
